export enum AppRoutes {
  ROOT = '',
  AUTH = 'auth',
  FIND_GAMES = 'find-games',
  GAMES = 'games',
  HOST = 'host',
  MY_GAMES = 'my-games',
  MESSAGES = 'messages',
  PROFILE = 'profile',
  NOTIFICATIONS = 'notifications',
  BLOCKED_VERSION = 'blocked-version',
  POLICY_PRIVACY = 'policy-privacy',
  POLICY_PRIVACY_CONTENT = 'policy-privacy-content',
  ADMIN_PANEL = 'admin',
  INTRODUCTION = 'introduction',
  INVITATIONS = 'invitations',
  DASHBOARD = 'dashboard',
  TEAMS = 'teams',
  WEB_BLOCKED = 'web-blocked',
  RANK = 'rank',
  CONNECTION_ERROR = 'connection-error'
}
